import Nullstack from 'nullstack';
export default function IconMailOpened({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-mail-opened",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("polyline", {
    points: "3 9 12 15 21 9 12 3 3 9"
  }), "   ", Nullstack.element("path", {
    d: "M21 9v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "19",
    x2: "9",
    y2: "13"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "13",
    x2: "21",
    y2: "19"
  }), " ");
}